exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1RfZ {\n    margin-bottom: 18px;\n    height: 64px;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: end;\n        align-items: flex-end;\n}\n\n._24ua {\n    min-width: 100px;\n}\n\n@media (max-width: 375px) {\n    ._1q7L {\n        margin-bottom: 40px;\n    }\n}\n\n.AAQq {\n    margin-bottom: 10px;\n}\n", ""]);

// exports
exports.locals = {
	"missingDegreeContainer": "_1RfZ",
	"monthOption": "_24ua",
	"areaOfStudy": "_1q7L",
	"paragraph": "AAQq"
};